import React from 'react';
import ClientContactForm from "../../forms/ClientContactForm";
import {Button, Icon} from "react-materialize";
import * as creationActions from "../../../actions/creation";
import * as clientContactActions from "../../../actions/clientContact";
import Dialog from "react-toolbox/lib/dialog/Dialog";

export default class ContactItem extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            dialogActive: false
        };
    }

    handleDelete = () => {
        this.props.dispatch(clientContactActions.deleteClientcontact(this.props.item.id));
    };

    render() {
        return (
            <tr>
                <td>{this.props.item.mainContact && <Icon className="center">star rate</Icon>}</td>
                <td>{this.props.item.name}</td>
                <td>{this.props.item.email}</td>
                <td style={{textAlign:'right'}}>
                    <Button floating onClick={() => this.props.openDrawer(ClientContactForm, {item: this.props.item, client: this.props.client}, creationActions.destroyingnewlyCreatedClientContact())} icon="edit" className="edit-button" />
                    <Button disabled={this.props.deletingClientcontact} floating onClick={()=> this.setState({dialogActive: true})} icon="delete" className="delete-button btn btn-floating"/>
                </td>
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false}) },
                        { label: "Yes", onClick: () => {this.handleDelete(); this.setState({dialogActive:false}); }}
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this contact ?</p>
                </Dialog>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/client/contact/ContactItem.js